import { Link, useLocation } from 'react-router-dom'
import Icon, { ChevronRightIcon } from '@design-systems/react-icons'
import { Card } from '@design-systems/canvas-ui'
import { useEssentials } from 'hooks/utils/useEssentials'
import { useLogClick } from 'utils/analytics'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { CategoryMarker, CategoryVariant } from './category-marker'
import { buildDetailsUrl, getInsightIcon, InsightsTab } from '../utils'
import './insight-card.scss'

export interface InsightCardProps {
    title: string
    summary: string
    index: number
    tab: InsightsTab
    icon?: string
    insightIcon?: string
    category?: { variant: CategoryVariant; label: string }
}

export const InsightCard = ({
    title,
    summary,
    index,
    tab,
    icon,
    insightIcon,
    category,
}: InsightCardProps) => {
    const { t } = useEssentials()
    const { logClick } = useLogClick('insights')
    const { insights: insightsKeys } = TRANSLATION_KEYS
    const location = useLocation()

    return (
        <Card
            as={Link}
            variant="elevated"
            to={buildDetailsUrl(index, location.search, tab)}
            className="insight-card hc8-pa-4x hc8-clr-base"
            aria-label={`${t(insightsKeys.viewInsightDetails)}: ${title}`}
            onClick={() =>
                logClick(
                    insightIcon
                        ? `insight card: ${tab}: ${insightIcon}`
                        : `insight card: ${tab}`,
                )
            }
        >
            {category && (
                <div className="hc8-mb-2x">
                    <CategoryMarker
                        variant={category.variant}
                        label={category.label}
                    />
                </div>
            )}
            <div className="insight-card__header hc8-mb-2x">
                <div
                    className="insight-card__icon hc8-mr-2x"
                    aria-hidden="true"
                >
                    <img src={icon ?? getInsightIcon(insightIcon)} alt="" />
                </div>
                <h3 className="insight-card__title hc8-fs-150 hc8-lh-headline hc8-clr-base">
                    <strong>{title}</strong>
                </h3>
                <span
                    className="insight-card__chevron hc8-clr-disabled"
                    aria-hidden="true"
                >
                    <Icon svg={ChevronRightIcon} aria-hidden />
                </span>
            </div>
            <p className="insight-card__summary hc8-fs-050 hc8-lh-body hc8-clr-disabled hc8-ma-none">
                {summary}
            </p>
        </Card>
    )
}
